import { useAuth } from './useAuth';
import { useGetUserCommissionGroups } from '@openapi/commission-groups/commission-groups';

// Self-read of the current user's commission-group assignments to discover
// whether they manage any group. Superadmins implicitly manage every group, so
// the lookup is skipped for them. Centralises the detection that several views
// (sidebar, reports, management page) would otherwise each re-implement.
export function useIsCommissionGroupManager() {
    const { user } = useAuth();
    const isSuperadmin = !!user?.isSuperAdmin;

    const { data, isLoading } = useGetUserCommissionGroups(
        Number(user?.venueId),
        Number(user?.id),
        {
            query: { enabled: !!user?.venueId && !!user?.id && !isSuperadmin },
        },
    );

    const managerAssignments = (data?.assignments ?? []).filter((a) => a?.isManager);

    return {
        isSuperadmin,
        isCommissionGroupManager: managerAssignments.length > 0,
        managerAssignments,
        managedGroupIds: managerAssignments.map((a) => a.commissionGroupId),
        isLoading: !isSuperadmin && isLoading,
    };
}
